import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { IUserResponse } from '../../interfaces/user.interface';
import { StorageService } from '../../../../core/services/storage/storage.service';
import { HairdressersService } from '../../../../shared/services/hairdressers/hairdressers.service';
import { map, catchError, of } from 'rxjs';

/**
 * Guard qui vérifie si le coiffeur a des services configurés.
 * Si le coiffeur n'a pas de services, il est redirigé vers la page d'onboarding.
 */
export const hasServicesGuard: CanActivateFn = (_route, _state) => {
    const router: Router = inject(Router);
    const storageService = inject(StorageService);
    const hairdressersService = inject(HairdressersService);

    const user: IUserResponse | null = storageService.getObject<IUserResponse>('USER');

    // Si pas d'utilisateur ou pas un coiffeur, laisser passer (d'autres guards s'en occuperont)
    if (!user || user.user_type !== 'hairdresser') {
        return true;
    }

    // Vérifier si le coiffeur a des services via l'API
    return hairdressersService.getHairdresserServices(user.id).pipe(
        map(response => {
            const hasServices = response?.listCoiffure && response.listCoiffure.length > 0;

            if (!hasServices) {
                // Pas de services, rediriger vers l'onboarding
                router.navigate(['/hairdresser/onboarding']);
                return false;
            }

            // A des services, permettre l'accès
            return true;
        }),
        catchError(() => {
            // En cas d'erreur API, laisser passer pour ne pas bloquer l'utilisateur
            console.error('Erreur lors de la vérification des services');
            return of(true);
        })
    );
};
